import * as React from "react";
import { Link } from "gatsby";
import { FiChevronRight } from "react-icons/fi";
import "twin.macro";

import SEO from "../components/seo";
import Layout from "../components/layout";
import Hero from "../components/hero";
import Services from "../components/services";
import WhyUs from "../components/whyus";
import NeedHlep from "../components/needhelp";
import Descriptive from "../components/descriptive";
import Gallery from "../components/gallery";
import Reviews from "../components/reviews";
import Contact from "../components/contact";
import locations from "../data/locations";

// Top locations to show as links (most important for SEO)
const TOP_LOCATIONS = [
  "harrislee", "handewitt", "gluecksburg", "muerwik", "weiche",
  "schleswig", "engelsby", "tarup", "langballig", "kappeln",
];

export default function IndexPage() {
  const topLocations = locations.filter((l) =>
    TOP_LOCATIONS.includes(l.slug)
  );

  return (
    <Layout>
      <SEO
        title="Garten- und Landschaftsbau Flensburg"
        description="A & F Garten- und Landschaftsbau Flensburg – Heckenschnitt, Rasenmähen, Pflasterarbeiten & Gartenpflege in Flensburg, Schleswig, Glücksburg, Harrislee und Umgebung. Jetzt Angebot anfragen!"
      />
      <Hero />
      <Services />
      <Gallery />
      <WhyUs />
      <Reviews />
      <NeedHlep />
      <Descriptive />

      {/* Einzugsgebiet – wichtig für lokales SEO */}
      <section id="einzugsgebiet" tw="bg-gray-50 py-20 px-6">
        <div tw="container mx-auto max-w-4xl text-center">
          <h2 tw="text-3xl lg:text-4xl font-medium text-secondary mb-4">
            Unser <span tw="text-primary">Einzugsgebiet</span>
          </h2>
          <p tw="text-gray-600 text-lg mb-10">
            Wir arbeiten in Flensburg und dem gesamten Umland – von Harrislee bis
            Schleswig, von Glücksburg bis Kappeln.
          </p>
          <div tw="flex flex-wrap justify-center gap-3">
            {topLocations.map((loc) => (
              <Link
                key={loc.slug}
                to={`/garten-und-landschaftsbau-${loc.slug}/`}
                tw="inline-flex items-center gap-1 bg-white border border-gray-200 rounded-full px-4 py-2 text-primary font-medium hover:border-primary hover:shadow-sm transition-all"
              >
                <FiChevronRight size={14} />
                {loc.name}
              </Link>
            ))}
          </div>
          <p tw="mt-8 text-gray-500 text-sm">
            Auch aus einem anderen Ort?{" "}
            <a href="#contact" tw="text-primary hover:underline">
              Einfach anfragen
            </a>{" "}
            – wir schauen ob wir helfen können.
          </p>
        </div>
      </section>

      <Contact />
    </Layout>
  );
}
